import React, {  } from "react";
import PropTypes from "prop-types";
//import { Link } from "react-router-dom";
import "./Subjective.scss";

const Subjective=()=> {


    return (
      <div className="subjective-container">
            <div className="">
              <input
                type="text"
                className="border-3 border-top-0 border-end-0 border-start-0  border-info bg-transparent"
                name="subjective"
                placeholder="write your answer."
                required
              />
        </div>
      </div>
    );
}

Subjective.propTypes = {
  option: PropTypes.string.isRequired,
  label:  PropTypes.string.isRequired,
  }

export default Subjective;
